export default __webpack_public_path__ + "static/icon-21-3-200c473b3ca1e1bf9ad4f438acce567f.png";